interface StepIndicatorProps {
  currentStep: number;
  completedSteps: Set<number>;
  onStepClick: (step: number) => void;
}

const STEPS = [
  { n: 1, label: 'Organisation' },
  { n: 2, label: 'Infrastructure' },
  { n: 3, label: 'Monitoring' },
  { n: 4, label: 'Compliance' },
  { n: 5, label: 'Estimate' },
];

export default function StepIndicator({ currentStep, completedSteps, onStepClick }: StepIndicatorProps) {
  return (
    <>
      {/* Desktop: numbered steps */}
      <div className="hidden sm:flex items-center justify-center gap-0 mb-8">
        {STEPS.map((step, i) => {
          const isDone = completedSteps.has(step.n);
          const isCurrent = currentStep === step.n;
          const isClickable = isDone || isCurrent;

          return (
            <div key={step.n} className="flex items-center">
              <button
                onClick={() => isClickable && onStepClick(step.n)}
                disabled={!isClickable}
                className={[
                  'flex flex-col items-center gap-1.5 px-3',
                  isClickable ? 'cursor-pointer' : 'cursor-default',
                ].join(' ')}
              >
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center text-[13px] font-bold border-2 transition-all"
                  style={isCurrent
                    ? { backgroundColor: '#0078d4', borderColor: '#0078d4', color: 'white' }
                    : isDone
                    ? { backgroundColor: 'rgba(0,120,212,0.15)', borderColor: '#0078d4', color: '#0078d4' }
                    : { backgroundColor: 'var(--surface-container)', borderColor: 'var(--outline-variant)', color: 'var(--text-tertiary)' }
                  }
                >
                  {isDone && !isCurrent
                    ? <span className="material-symbols-outlined text-[16px]">check</span>
                    : step.n}
                </div>
                <span
                  className="text-[10px] font-bold uppercase tracking-wide whitespace-nowrap"
                  style={{ color: isCurrent ? 'var(--text-secondary)' : isDone ? 'var(--text-tertiary)' : 'var(--text-tertiary)' }}
                >
                  {step.label}
                </span>
              </button>
              {i < STEPS.length - 1 && (
                <div
                  className="w-12 h-[2px] mb-5 transition-all"
                  style={{ backgroundColor: completedSteps.has(step.n) ? '#0078d4' : 'var(--outline-variant)' }}
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Mobile: text + progress bar */}
      <div className="sm:hidden mb-6">
        <div className="flex justify-between items-center mb-2">
          <span className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>Step {currentStep} of 5</span>
          <span className="text-[12px] font-semibold" style={{ color: 'var(--text-secondary)' }}>{STEPS[currentStep - 1].label}</span>
        </div>
        <div className="h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: 'var(--outline-variant)' }}>
          <div
            className="h-full bg-[#0078d4] transition-all duration-300"
            style={{ width: `${(currentStep / 5) * 100}%` }}
          />
        </div>
      </div>
    </>
  );
}
